export default function publicPostLink(row, configuredOrigin) {
  const path = row && row.post && row.post.publicPath
  if (typeof path !== 'string' || !/^\/blog\//.test(path) || /[?#\\\s]/.test(path)) return null
  try {
    const decoded = decodeURIComponent(path)
    if (/[\\?#]/.test(decoded) || Array.from(decoded).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127) || decoded.split('/').some(part => part === '.' || part === '..' || part.includes('%'))) return null
    const origin = new URL(configuredOrigin)
    if (!['https:', 'http:'].includes(origin.protocol) || origin.username || origin.password || origin.search || origin.hash || !['', '/'].includes(origin.pathname)) return null
    const target = new URL(path, origin.origin)
    return target.origin === origin.origin && target.pathname.startsWith('/blog/') ? target.href : null
  } catch (_) {
    return null
  }
}
